import { createSlice } from "@reduxjs/toolkit";

const wfTrackingSlice = createSlice({
  name: "wftracking",
  initialState: {
    workflowSummaryData: [],
    filteredWFSummaryData: [],
    loading: false,
  },
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setWorkflowSummaryData(state, action) {
      state.workflowSummaryData = action.payload;
    },
    setFilteredWFSummaryData(state, action) {
      state.filteredWFSummaryData = action.payload;
    },
  },
});

export const { setLoading, setWorkflowSummaryData, setFilteredWFSummaryData } =
  wfTrackingSlice.actions;

export default wfTrackingSlice.reducer;
